<template>
  <Modal
    v-model="_value"
    width="500"
    title="ZT设置司机卡"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="90">
      <FormItem prop="driverName" label="驾驶员名">
        <Input v-model="setDriverCardParams.driverName" placeholder="请输入驾驶员名">
        </Input>
      </FormItem>
<!--      <FormItem prop="driverCardNum" label="从业资格证号">-->
<!--        <Input v-model="setDriverCardParams.driverCardNum" placeholder="请输入从业资格证号">-->
<!--        </Input>-->
<!--      </FormItem>-->
      <FormItem prop="driverLicenseNum" label="驾驶证号">
        <Input v-model="setDriverCardParams.driverLicenseNum" placeholder="请输入驾驶证号">
        </Input>
      </FormItem>
      <FormItem prop="organizationNames" label="发证机构名称">
        <Input v-model="setDriverCardParams.organizationNames" placeholder="请输入发证机构名称">
        </Input>
      </FormItem>
      <FormItem prop="indate" label="证件有效期">
        <DatePicker style="display: inline-block; width: 200px;" type="date" v-model="setDriverCardParams.indate"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'ztsetdrivercardmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        driverCardNum: null,
        driverName: null,
        driverLicenseNum: null,
        organizationNames: null,
        indate: null,
      }

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.driverCardNum = null
        this.setDriverCardParams.driverName = null
        this.setDriverCardParams.driverLicenseNum = null
        this.setDriverCardParams.organizationNames = null
        this.setDriverCardParams.indate = null
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.driverCardNum = null
      this.setDriverCardParams.driverName = null
      this.setDriverCardParams.driverLicenseNum = null
      this.setDriverCardParams.organizationNames = null
      this.setDriverCardParams.indate = null
    },
    onSendDriverCardParams () {


      if (this.setDriverCardParams.driverName == null) {
        this.$Message.error('驾驶员名不能为空')
        return
      }
      if (this.setDriverCardParams.driverLicenseNum == null) {
        this.$Message.error('驾驶证号不能为空')
        return
      }
      this.setDriverCardParams.driverCardNum = this.setDriverCardParams.driverLicenseNum
      if (this.setDriverCardParams.driverCardNum == null) {
        this.$Message.error('从业资格证号不能为空')
        return
      }
      if (this.setDriverCardParams.organizationNames == null) {
        this.$Message.error('发证机构名称不能为空')
        return
      }
      if (this.setDriverCardParams.indate == null){
        this.$Message.error("请输入有效期")
      }else {
        this.setDriverCardParams.indate = this.setDriverCardParams.indate.Format('yyyyMMdd').substring(2)
      }
      console.log('##_ZTTtsSet;STICCARD;姓名='+this.setDriverCardParams.driverName+',从业资格证号='+this.setDriverCardParams.driverCardNum+',驾驶证号='+this.setDriverCardParams.driverLicenseNum+',发证机构='+ this.setDriverCardParams.organizationNames+',有效期=' + this.setDriverCardParams.indate + '$')
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: '##_ZTTtsSet;STICCARD;姓名='+this.setDriverCardParams.driverName+',从业资格证号='+this.setDriverCardParams.driverCardNum+',驾驶证号='+this.setDriverCardParams.driverLicenseNum+',发证机构='+ this.setDriverCardParams.organizationNames+',有效期=' + this.setDriverCardParams.indate + '$', urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
